<template>
  <div>
    <md-snackbar :md-active.sync="snackbar.show" :md-duration="8000">
      <span>
        <template>
          <md-icon class="md-primary">{{ snackbar.icon }}</md-icon>
          &nbsp;&nbsp;&nbsp;
        </template>
        {{ snackbar.content }}
      </span>
      <md-button class="md-primary md-simple md-dense" @click="snackbar.show = false">
        Dismiss
      </md-button>
    </md-snackbar>
    <group-card title="Brokers" icon="connect_without_contact" padded>
      <div data-app>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details>
        </v-text-field>
        <v-data-table :headers="leadRequestHeader"
          :items="leadRequests"
          :search="search"
          item-key="id"
          :items-per-page="10"
          class="elevation-0 lead_requests_table"
          :footer-props="{
            showFirstLastPage: true,
            firstIcon: 'first_page',
            lastIcon: 'last_page',
            prevIcon: 'skip_previous',
            nextIcon: 'skip_next'
          }"
          :loading="loading"
          loading-text="Loading... Please wait"
        >
          <!-- Formatting the date -->
          <template v-slot:item.allocation_month="{ item }">
            {{ formatDate(item.allocation_month) }}
          </template>
          <template v-slot:item.actions="{ item }">
            <loading-icon-button v-if="isRequestEditable(item)" @click="editLeadRequest(item)"  tooltip="Edit number of leads">
              edit
            </loading-icon-button>
          </template>
        </v-data-table>
      </div>
    </group-card>
    <!-- Number of leads Dialog Start -->
    <ValidationObserver v-slot="{ invalid }">
      <md-dialog :md-active.sync="show.request_send_dialog">
        <md-dialog-title></md-dialog-title>
        <div v-if="errorMessage">
          <p class="errorMsg">{{ errorMessage }}</p>
        </div>
        <p class="infoMsg">Please type the number of leads for selected broker</p>
        <div class="md-layout">
          <validated-number-input class="md-layout-item md-size-55 field" label="SQL Leads Number"
            v-model="requestFields.leadsNumber.new_value">
          </validated-number-input>
        </div>
        <div class="md-layout">
          <validated-number-input class="md-layout-item md-size-55 field" label="MQL Leads Number"
            v-model="requestFields.leadsNumber.mql_new_value">
          </validated-number-input>
        </div>
        <md-dialog-actions>
          <md-button class="md-primary md-simple" @click="editLeadRequestCancel">Cancel</md-button>
          <md-button class="md-primary md-simple" @click="saveLeadRequest" :disabled="invalid">
            Save
          </md-button>
        </md-dialog-actions>
      </md-dialog>
    </ValidationObserver>
    <!-- Number of leads Dialog End -->
  </div>
</template>
<script>
import { GroupCard } from "@/components";
import { mapGetters } from "vuex";
import ValidatedInputs from '@/components/ValidatedInput';
import LoadingIconButton from "@/components/LoadingIconButton";
import moment from "moment";

export default {
  components: {
    GroupCard,
    ...ValidatedInputs,
    LoadingIconButton
  },
  data() {
    return {
      isUpdating: false,
      errorMessage: null,
      snackbar: {
        show: false,
        icon: "done",
        content: "Number of leads saved successfully",
      },
      search: '',
      loading: false,
      requestFields: {
        id: false,
        leadsNumber: { 'new_value': '' }
      },
      leadRequestHeader: [
        { text: 'Pod', value: 'pod_name', align: 'center' },
        { text: 'Broker Name', value: 'full_name', align: 'center' },
        { text: 'Lead Request For', value: 'allocation_month', align: 'center' },
        { text: 'SQL Required Leads', value: 'required_leads', align: 'center', },
        { text: 'MQL Required Leads', value: 'mql_required_leads', align: 'center', },
        { text: 'Actions', value: 'actions', align: 'center', sortable: false },
      ],
      show: {
        request_send_dialog: false
      },
    }
  },
  created() {
    this.loadLeadRequests();
  },
  computed: {
    ...mapGetters({
      leadRequests: 'leadRequests',
      user: "user",
      userHasRole: 'userHasRole',
      isPodManager: 'isPodManager'
    }),
  },
  methods: {
    async loadLeadRequests() {
      this.loading = true;
      try {
        if (this.userHasRole('super-admin')) {
          await this.$store.dispatch('fetch_all_lead_requests');
        } else if (this.isPodManager) {
          await this.$store.dispatch('fetch_lead_requests_by_pod', this.user.primary_pod);
        }
        else if (this.userHasRole('Broker')) {
          await this.$store.dispatch('fetch_lead_requests_by_broker', this.user.id);
          await this.$store.dispatch('fetch_lead_requests_by_user');
        }
      } catch (error) {
        this.errorMessage = 'Failed to load lead requests.';
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    editLeadRequestCancel() {
      this.errorMessage = '';
      this.show.request_send_dialog = false;
    },
    editLeadRequest(item) {
      this.errorMessage = '';
      this.requestFields.id = item.id
      this.requestFields.leadsNumber.new_value = item.required_leads;
      this.requestFields.leadsNumber.mql_new_value = item.mql_required_leads;
      this.show.request_send_dialog = true;
    },
    isRequestEditable(item) {
      const isEndMonth = this.is7DaysPrior(item.allocation_month);
      const isLeadRequestRequired = this.checkLeadsSubmmited(item);
      return isEndMonth || isLeadRequestRequired;
    },
    is7DaysPrior(allocationMonth) {
      const allocationDate = moment(allocationMonth);
      const lastDayPrevMonth = allocationDate.subtract(1, 'month').endOf('month').format('YYYY-MM-DD');
      const startOfAllowedPeriod = moment(lastDayPrevMonth).subtract(7, 'days').format('YYYY-MM-DD');
      const today = moment();
      return today.isBetween(startOfAllowedPeriod, lastDayPrevMonth, null, '[]');
    },
    checkLeadsSubmmited(item) {
        // Allow editing 0 values in current allocated month
        return this.isCurrentMonth(item) && this.isMqlLSqlNotProvided(item);
    },
    isCurrentMonth(item) {
        const allocationDate = moment(item.allocation_month, 'YYYY-MM');
        const today = moment();
        return today.isSame(allocationDate, 'month');
    },
    isMqlLSqlNotProvided(item) {
        return ((item.required_leads == null || item.required_leads == "0") && (item.mql_required_leads == null || item.mql_required_leads == "0"));
    },
    formatDate(date) {
      return moment(date).format("MMMM YYYY"); // Example: "January 2025"
    },
    async saveLeadRequest() {
      try {
        if (!this.requestFields.leadsNumber.new_value) {
          this.errorMessage = 'Please provide a valid number of leads.';
          return;
        }
        if (!this.requestFields.leadsNumber.mql_new_value) {
          this.errorMessage = 'Please provide a valid number of leads.';
          return;
        }

        const payload = {
          id: this.requestFields.id,
          user_id: this.user.id,
          required_leads: this.requestFields.leadsNumber.new_value,
          mql_required_leads: this.requestFields.leadsNumber.mql_new_value
        };

        const result = await this.$store.dispatch('save_lead_request', payload);

        if (result.success) {
          // Parse the date with Moment.js
          const leadAllocatedMonth = moment(result.data.allocation_month);

          // Get the start of the current month and the start of the previous month
          const startOfThisMonth = moment().startOf('month');
          const startOfPreviousMonth = moment().subtract(1, 'month').startOf('month');

          if(result.data.user_id == this.user.id
            && leadAllocatedMonth.isBetween(startOfPreviousMonth, startOfThisMonth, null, '[]')) {

            if(result.data.required_leads != 0
              && result.data.mql_required_leads != 0) {
              this.$store.commit('set_lead_requests_forecasts', true);
            } else {
              this.$store.commit('set_lead_requests_forecasts', false);
            }
          }

          this.snackbar.content = "Number of leads saved successfully";
          this.snackbar.show = true;

          // Refresh lead requests after saving
          this.loadLeadRequests();
        } else {
          this.errorMessage = 'Failed to save the number of leads. Please try again.';
        }
      } catch (error) {
        console.error('Error saving leads number:', error);
        this.errorMessage = 'An error occurred while saving the number of leads.';
      } finally {
        this.show.request_send_dialog = false;
      }
    },
  }
}

</script>
<style lang="scss" scoped>
.lead_requests_table {
  table {
    td {
      text-align: center;
    }
  }

  .v-data-footer__select {
    display: none;
  }
}

.errorMsg,
.infoMsg {
  padding: 0px 20px;
}

.field {
  margin-right: 20px;
}
</style>
